import { Directive, OnInit, Input } from '@angular/core';


@Directive({
  selector: '[byte-image]'
})
export class ImageDirective {
  imageData: any;
  @Input('byte-image') image: any;

  constructor() {
    this.imageData = 'data:image/png;base64,' + this.image.text;
  }

}



// WEBPACK FOOTER //
// C:/Software Development/Devpark/biz-app/src/app/shared/directives/image.directive.ts